import { useSessionStore } from '@/stores/session'

export default {
  install(app) {
    // Create a session-like interface for backward compatibility
    const sessionAPI = {
      start: () => {
        // In vue-session, start() was used to initialize the session
        // For our implementation, we don't need to do anything special
        console.log('Session started (compatibility mode)')
        return true
      },
      get: (key) => {
        const store = useSessionStore()
        return store.get(key)
      },
      set: (key, value, persist = true) => {
        const store = useSessionStore()
        return store.set(key, value, persist)
      },
      remove: (key) => {
        const store = useSessionStore()
        return store.remove(key)
      },
      clear: () => {
        const store = useSessionStore()
        return store.clear()
      },
      destroy: () => {
        const store = useSessionStore()
        return store.clear()
      },
      exists: (key) => {
        const store = useSessionStore()
        return store.exists(key)
      }
    }
    
    // Make it available globally as $session
    app.config.globalProperties.$session = sessionAPI
  }
}
